<template>
  <div
    class="w-full max-w-[1340px] mx-auto mt-10 tablet-h:mt-[30px] flex items-center justify-between"
  >
    <DacrWordLogo class="w-[95px]" />

    <RouterLink :to="userStore.isSignedIn ? '/home' : '/register'">
      <Button variant="stroke" size="lg">Register your work</Button>
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@dacr/library'
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import { useUserStore } from '@/shared/stores/user'

const userStore = useUserStore()
</script>
